<div class="offline-notice" *ngIf="!connected">
  <p translate>i18n.error.offlineNotice</p>
</div>



// WEBPACK FOOTER //
// ./src/app/offline-notice.component.html